/** Mirrors crm DealStage / common CurrencyChoices. */
export const DEAL_STAGES = [
  { value: 'qualified', label: 'Qualified' },
  { value: 'proposal', label: 'Proposal' },
  { value: 'negotiation', label: 'Negotiation' },
  { value: 'won', label: 'Won' },
  { value: 'lost', label: 'Lost' },
] as const;

export type DealStage = (typeof DEAL_STAGES)[number]['value'];

export const CURRENCIES = ['USD', 'EUR', 'GBP', 'AUD'] as const;
export type Currency = (typeof CURRENCIES)[number];

/** Mirrors finance CommissionBasis (ADR-046). `none` = this deal pays nothing. */
export const COMMISSION_BASES = [
  { value: 'none', label: 'No commission' },
  { value: 'first_client_invoice', label: 'First client invoice (new clients only)' },
  { value: 'all_paid_invoices', label: 'All paid invoices' },
] as const;

export type CommissionBasis = (typeof COMMISSION_BASES)[number]['value'];

export const commissionBasisLabel = (basis: string): string =>
  COMMISSION_BASES.find((b) => b.value === basis)?.label ?? basis;

export const stageLabel = (stage: string): string =>
  DEAL_STAGES.find((s) => s.value === stage)?.label ?? stage;

/** Badge variant per stage for the UI. */
export function stageVariant(stage: string): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (stage === 'won') return 'default';
  if (stage === 'lost') return 'destructive';
  if (stage === 'negotiation' || stage === 'proposal') return 'secondary';
  return 'outline';
}

/** Mirrors crm DealLostReason (ADR-108) — required while a deal is Lost. */
export const LOST_REASONS = [
  { value: 'price', label: 'Price' },
  { value: 'timing', label: 'Timing' },
  { value: 'competitor', label: 'Chose a competitor' },
  { value: 'no_budget', label: 'No budget' },
  { value: 'no_response', label: 'No response' },
  { value: 'not_a_fit', label: 'Not a fit' },
  { value: 'scope', label: 'Scope' },
  { value: 'other', label: 'Other' },
] as const;

export type LostReason = (typeof LOST_REASONS)[number]['value'];

export const lostReasonLabel = (v: string): string =>
  LOST_REASONS.find((x) => x.value === v)?.label ?? v;
